module.exports = __webpack_public_path__ + "img/mapHerault.974d111.jpg";